<template>
    <SelectSite
        @filter-change="pick(undefined)"
        class="step-one-container"
        @pick="pick"
        :selectedSite="selectedSite"
        :title="$t('siteSelection.searchBar.title.reclamation')"
    />
</template>

<script lang="ts">
import SelectSite from '@/modules/SiteList/components/SelectSite.vue';
import { Site } from '@/models/Site';
import { defineComponent } from 'vue';

export default defineComponent({
    components: { SelectSite },
    props: { selectedSite: { type: Object, required: false } },
    methods: {
        pick(site: Site): void {
            if (site) {
                this.$emit('selectSite', site);
            }
        },
    },
});
</script>

<style scoped>
.step-one-container {
    margin-top: 8px;
    background-color: var(--white);
    box-shadow: 0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 2px 2px rgba(0, 0, 0, 0.14), 0 1px 5px rgba(0, 0, 0, 0.12);
    max-height: calc(100vh - 225px);
    border-radius: 6px;
}
</style>
